module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-progress"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Progress")]), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "默认"
    }
  }, [_c('mt-progress')], 1), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "设置 value"
    }
  }, [_c('mt-progress', {
    attrs: {
      "value": 20
    }
  })], 1), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "左右文字"
    }
  }, [_c('mt-progress', {
    attrs: {
      "value": 40
    }
  }, [_c('div', {
    slot: "start"
  }, [_vm._v("0%")]), _vm._v(" "), _c('div', {
    slot: "end"
  }, [_vm._v("100%")])])], 1), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "定义线宽"
    }
  }, [_c('mt-progress', {
    attrs: {
      "value": 60,
      "bar-height": 5
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "page-progress-wrapper"
  }, [_c('mt-button', {
    attrs: {
      "size": "large",
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.uploadFile($event)
      }
    }
  }, [_vm._v("上传文件")]), _vm._v(" "), (_vm.progressVisible) ? _c('mt-progress', {
    attrs: {
      "value": _vm.value,
      "transition": "progress-fade"
    }
  }, [_c('div', {
    slot: "end"
  }, [_vm._v(_vm._s(_vm.value) + "%")])]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31598da8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./example/pages/progress.vue
// module id = 282
// module chunks = 0